__turbopack_context__.v({
  "bot": "style-module-scss-module__Y4ytsG__bot",
  "glitchText": "style-module-scss-module__Y4ytsG__glitchText",
  "top": "style-module-scss-module__Y4ytsG__top",
});
